import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { ApolloProvider } from "@apollo/client";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { BrowserRouter } from "react-router-dom";
import store from "./store";
import client from "./graphQL";
import theme from "./libs/theme";
import { LayoutProvider } from "./contexts/LayoutContext";
import { FeatureToggleProvider } from "./contexts/FeatureToggleContext";
import WebLLMProvider from "./contexts/WebLLMContext";
import { RemoteLLMProvider } from "./contexts/RemoteLLMContext";
import { UploadProvider } from "./Provider/UploadContext";
import { handleAuthRedirect } from "./utils/authSession";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
import "./styles/index.scss";

// Extract tokens from URL BEFORE React renders.
// This must run synchronously so localStorage is populated
// before any component checks hasStoredAuthToken().
handleAuthRedirect();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <ApolloProvider client={client}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <LayoutProvider>
            <FeatureToggleProvider>
              <WebLLMProvider>
                <RemoteLLMProvider>
                  <UploadProvider>
                    <App />
                    <ToastContainer />
                  </UploadProvider>
                </RemoteLLMProvider>
              </WebLLMProvider>
            </FeatureToggleProvider>
          </LayoutProvider>
        </BrowserRouter>
      </ThemeProvider>
    </ApolloProvider>
  </Provider>
);
